<template>
  <div class="list">
    <div v-if="this.items.length === 0">
      <div class="callout warning">
        <p class="title">Keine Kurse vorhanden</p>
        <p class="text">
          Mit den hinterlegten Filtern sind leider Kurse vorhanden. Sie können
          uns aber gerne per E-Mail kontaktieren mit Ihren Wünschen.<br />
          <br />
          <a :href="'mailto:' + settings.email">{{ settings.email }}</a>
        </p>
      </div>
    </div>
    <div v-else class="row">
      <div
        class="course col l50 bordered bgWhite"
        v-for="item of this.currentItems"
        :key="item.id"
      >
        <div class="days">
          <div
            class="day"
            v-for="weekday in weekdays"
            :class="checkDayOfWeek(item, weekday.dow) ? '' : 'disabled'"
            :key="item.id + '-' + weekday.dow"
          >
            <span class="weekday">{{ weekday.text }}</span>
            <span class="time">{{ getTimeByWeekday(item, weekday.dow) }}</span>
          </div>
        </div>

        <h2 class="title">{{ item.title }}</h2>

        <Tags :items="item.tags"></Tags>

        <CourseWorkload
          :load="item.workload"
          :capacity="item.capacity"
          class="space"
        ></CourseWorkload>

        <div class="courseDetails">
          <div class="courseDetail bath">
            <span class="courseDetailTitle">Bad:</span>
            <span class="courseDetailDescription">
              <Accordion
                :id="'location-' + item.id"
                aria-title="Adresse einblenden"
                :title="item.bath.title"
              >
                <div class="locationDetails">
                  {{ item.bath.street }} <br />
                  {{ item.bath.postal }} {{ item.bath.city }}
                </div>
              </Accordion>
            </span>
          </div>
          <div class="courseDetail instructor">
            <span class="courseDetailTitle">Trainer:</span>
            <span class="courseDetailDescription">{{ item.instructor }}</span>
          </div>
          <div class="courseDetail date">
            <template
              v-if="item.type === 'course' || item.type === 'hybrid-course'"
            >
              <span class="courseDetailTitle">Zeitraum:</span>
              <span class="courseDetailDescription"
                >{{ item.startDate | formatDate }} -
                {{ item.endDate | formatDate }}</span
              >
            </template>
            <template v-if="item.type === 'club'">
              <span class="courseDetailTitle">Startdatum:</span>
              <span class="courseDetailDescription">{{
                item.startDate | formatDate
              }}</span>
            </template>
          </div>
          <div class="courseDetail courseId">
            <span class="courseDetailTitle">Kurs-ID:</span>
            <span class="courseDetailDescription">{{ item.id }}</span>
          </div>
          <div class="courseDetail price">
            <span class="courseDetailTitle">Preise:</span>
            <span class="courseDetailDescription">
              <CoursePrice
                :price="item.price"
                :priceReduced="item.priceReduced"
                :type="item.type"
              />
            </span>
          </div>
          <div class="courseDetail duration">
            <span class="courseDetailTitle">Dauer:</span>
            <span class="courseDetailDescription"
              >{{ item.duration }} Minuten</span
            >
          </div>

          <Accordion
            :id="'dates-' + item.id"
            aria-title="Alle Termine des Kurses einblenden"
            title="Termine einblenden"
            activeTitle="Termine ausblenden"
            icon-position="left"
          >
            <div class="courseDates row" v-if="item.events.length > 0">
              <div
                class="courseDate col s50"
                v-for="event in item.events"
                :key="event.id"
              >
                <span class="day">{{ getDayOfWeek(event.dow) }}. </span
                ><span class="date">{{ event.date }} </span
                ><span class="time">{{ event.time }} Uhr</span>
              </div>
            </div>
          </Accordion>
        </div>

        <div class="order">
          <template v-if="item.type === 'club'">
            <router-link
              v-if="item.capacity - item.workload > 0"
              :to="{ name: 'booking', params: { courseId: item.id } }"
              tag="button"
              class="button"
              >Buchen
            </router-link>
            <router-link
              v-else
              :to="{
                name: 'waitingList',
                params: {
                  baths: baths,
                  categories: categories,
                  courseId: item.id
                }
              }"
              tag="button"
              class="button"
              >Warteliste
            </router-link>
          </template>
          <template v-else>
            <router-link
              v-if="item.capacity - item.workload > 0"
              :to="{ name: 'booking', params: { courseId: item.id } }"
              tag="button"
              class="button"
              >Buchen
            </router-link>
            <button class="button" v-else disabled>Ausgebucht</button>
          </template>
        </div>
      </div>
    </div>
    <div class="pagination">
      <ul>
        <li v-if="items.length > 0" @click="changePage(currentPage - 1)">
          <button
            class="button"
            title="Zur vorherigen Listen-Seite navigieren"
            :disabled="currentPage <= 1"
          >
            <svg
              width="11"
              height="18"
              viewBox="0 0 11 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 1L1 9L10 17"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </li>
        <template v-for="page in maxPages">
          <li
            :key="page"
            @click="changePage(page)"
            v-if="page + 2 >= currentPage && page - 2 <= currentPage"
          >
            <button
              :title="'Zur Seite ' + page + ' navigieren'"
              :class="'button' + (currentPage === page ? ' active' : '')"
              :disabled="currentPage === page"
            >
              <span class="title">{{ page }}</span>
            </button>
          </li>
        </template>
        <li v-if="items.length > 0" @click="changePage(currentPage + 1)">
          <button
            class="button"
            title="Zur nächsten Listen-Seite navigieren"
            :disabled="currentPage >= maxPages"
          >
            <svg
              width="11"
              height="18"
              viewBox="0 0 11 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 17L10 9L1 1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CourseWorkload from "@/components/CourseWorkload.vue";
import Accordion from "@/components/Accordion.vue";
import Tags from "@/components/Tags.vue";
import CoursePrice from "@/components/CoursePrice.vue";

export default {
  name: "CourseListing",
  components: { CoursePrice, Tags, CourseWorkload, Accordion },
  props: ["items", "settings"],
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      weekdays: [
        { dow: 1, text: "Mo" },
        { dow: 2, text: "Di" },
        { dow: 3, text: "Mi" },
        { dow: 4, text: "Do" },
        { dow: 5, text: "Fr" },
        { dow: 6, text: "Sa" },
        { dow: 0, text: "So" }
      ]
    };
  },
  computed: {
    currentItems: function() {
      const vue = this;
      if (vue.items.length > 0)
        return vue.items.slice(
          (vue.currentPage - 1) * vue.itemsPerPage,
          vue.currentPage * vue.itemsPerPage
        );
      return [];
    },
    maxPages: function() {
      if (this.items !== undefined && this.items.length > 0)
        return parseInt(Math.ceil(this.items.length / this.itemsPerPage));
      return 0;
    }
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
      this.$refs.top.scrollIntoView({ behavior: "smooth" });
    },
    getDayOfWeek(dow) {
      return this.weekdays.filter(weekday => weekday.dow == dow)[0].text;
    },
    checkDayOfWeek(item, dow) {
      return item.dayOfWeeks.indexOf(dow) !== -1;
    },
    getTimeByWeekday(item, dow) {
      if (item.timeslots[dow] !== undefined) {
        return item.timeslots[dow];
      }

      return "00:00";
    }
  }
};
</script>

<style scoped lang="scss">
.course {
  container: courseCard / inline-size;
  position: relative;
  display: flex;
  flex-flow: column nowrap;

  & + .course {
    margin-top: var(--gridGapY);
  }

  @media (min-width: 980px) {
    &:nth-child(2) {
      margin-top: 0;
    }
  }

  .days {
    --daysColumns: 7;
    --daysGapX: 10px;
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 20px;

    .day {
      background-color: var(--ghostWhite);
      border-radius: var(--inputBorderRadius);
      width: calc(
        (100% - ((var(--daysColumns) - 1) * var(--daysGapX))) /
          var(--daysColumns)
      );
      margin-right: var(--daysGapX);
      padding: 1rem 0;
      text-align: center;

      &.disabled {
        display: none;
      }

      &:last-child {
        margin-right: 0;
      }

      @media (min-width: 980px) {
        padding: 0.5rem 0;
      }
    }

    .weekday,
    .time {
      display: block;
      font-weight: var(--fontWeightBold);
      line-height: 1.1;
    }

    .weekday {
      font-size: 1.6667rem;
      color: var(--blue);
    }

    .time {
      font-size: 0.75rem;
      color: var(--gray);
    }
  }

  .area {
    text-align: right;
    margin: 1rem 0;

    @media (max-width: 640px) {
      margin-top: 1rem;
      text-align: left;
    }

    button {
      background-color: #be4023;
      color: #fff;
      text-transform: uppercase;
      letter-spacing: 0.2rem;

      &.family {
        background-color: #0078bf;
      }

      &.child {
        background-color: #00376d;
      }
    }
  }

  .space {
    margin: 20px 0;
  }

  .order {
    margin-top: 1rem;
    text-align: right;
  }

  @container (min-width: 320px) {
    .order {
      position: absolute;
      z-index: 5;
      right: var(--gridGapX);
      bottom: var(--gridGapY);
      text-align: right;
    }
  }
}
</style>
